import request from './request';

export async function list(page: number, perPage: number, name?: string) {
  return request('GET', '/api/partners', { page, perPage, name });
}

export async function create(
  name?: string,
  nameEn?: string,
  nameDe?: string,
  description?: string,
  descriptionEn?: string,
  descriptionDe?: string,
  descriptionLong?: string,
  descriptionLongEn?: string,
  descriptionLongDe?: string,
  annotation?: string,
  annotationEn?: string,
  annotationDe?: string,
  link?: string
) {
  return request('POST', '/api/partners', {
    name,
    nameEn,
    nameDe,
    description,
    descriptionEn,
    descriptionDe,
    descriptionLong,
    descriptionLongEn,
    descriptionLongDe,
    annotation,
    annotationEn,
    annotationDe,
    link,
  });
}

export async function update(
  id: string,
  name?: string,
  nameEn?: string,
  nameDe?: string,
  description?: string,
  descriptionEn?: string,
  descriptionDe?: string,
  descriptionLong?: string,
  descriptionLongEn?: string,
  descriptionLongDe?: string,
  annotation?: string,
  annotationEn?: string,
  annotationDe?: string,
  link?: string
) {
  return request('POST', `/api/partners/${id}`, {
    name,
    nameEn,
    nameDe,
    description,
    descriptionEn,
    descriptionDe,
    descriptionLong,
    descriptionLongEn,
    descriptionLongDe,
    annotation,
    annotationEn,
    annotationDe,
    link,
  });
}

export async function remove(id: string) {
  return request('DELETE', `/api/partners/${id}`);
}
